<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="0" :rules="rules">
      <el-form-item prop="mobile">
        <el-input v-model="ruleForm.mobile" disabled />
      </el-form-item>
      <el-form-item prop="verificatCode">
        <el-input v-model="ruleForm.verificatCode"  />
        <span v-if="!mobile_verificat_timer" class="verificatCode" @click="sendValiMess">发送验证码</span>
        <span v-else class="verificatTime">{{mobile_verificat_time}}s后, 重新发送</span>
      </el-form-item>
      <el-form-item style="text-align: left;" label-width="0">
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog qd" @click="handleVerificat">确定</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import { mapGetters } from 'vuex'

export default {
  name: '',
  data () {
    return {
      ruleForm: {
        mobile: '',
        verificatCode: ''
      },
      rules: {
        verificatCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    ...mapGetters(['mobile_verificat_time', 'mobile_verificat_timer'])
  },

  created () {
    this.getMobile()
  },

  methods: {
    getMobile () {
      const mobile = localStorage.mobile
      if (mobile) {
        const Base64 = require('js-base64').Base64
        const decodeMobile = Base64.decode(mobile)
        this.ruleForm.mobile = decodeMobile.substr(0, 3) + '****' + decodeMobile.substr(7)
      }
    },
    sendValiMess () {
      Backend.post(this, '/user/send_validate_message').then(() => {
        this.$message.success('验证码已发送, 请注意查收')
        this.$store.commit('main/openTimeInterval')
      })
    },
    handleVerificat () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Backend.post(this, '/user/validate_code', { code: this.ruleForm.verificatCode }).then(() => {
            this.$emit('tableCloseDialog')
            this.$message.success('校验通过!')
            this.$resetSetItem('is_validated', true)
            this.$store.commit('main/clearTimeInterval')
          })
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
  .verificatCode{
    cursor: pointer;
    padding: 4px 8px;
    color: #5ca7f4;
    background: #e4e4e4;
  }
  .verificatTime{
    color: #f56c6c;
  }
</style>
